import { withSizes } from 'components/helpers'
import { useRouter } from 'next/router'
import * as R from 'ramda'
import { useState } from 'react'
import { useQuery } from 'react-query'
import Feed from 'routes/Home/components/Feed'
import styled from 'styled-components'

import * as S from './Feed.styles'
import { doLoadFeed, doLoadTags } from '../modules/datasource'

const defaultProps = {}
const propTypes = {}

const StyledFeed = styled(Feed)`
  padding-top: 0;
`

const tabs = [
  { label: 'Popular', value: 'Popular', componentType: 'Question' },
  { label: 'Latest', value: 'Latest', componentType: 'Question' },
  { label: 'Trending', value: 'Trending', componentType: 'Question' },
]

const getCrrTags = tags => {
  return R.isEmpty(tags) || R.isNil(tags) ? [] : tags.split(',')
}

export const AMQFeed = () => {
  const router = useRouter()
  const { tab = 'Popular', tags } = router.query

  const crrTab = R.any(R.propEq(tab, 'value'), tabs) ? tab : 'Popular'

  const [tagList, setTagList] = useState([])

  const changeTab = tab => {
    window?.scroll(0, 0)
    const tag = tags ? `&tags=${tags}` : ''
    router.push(`/questions?tab=${tab}${tag}`, undefined, {
      shallow: true,
    })
  }
  const changePage = page => {
    window?.scroll(0, 0)
    const tag = tags ? `&tags=${tags}` : ''
    router.push(`/questions?tab=${crrTab}&page=${page}${tag}`, undefined, {
      shallow: true,
    })
  }

  const customLoad = async ({ page, accessToken, tags }) => {
    return await doLoadFeed({
      type: tab,
      page,
      tagSlugs: getCrrTags(tags),
      accessToken,
    })
  }

  useQuery(['questions-tags'], () => doLoadTags(), {
    fetchPolicy: 'no-cache',
    onSuccess: setTagList,
  })

  const updateTagFilter = tag => {
    const crrTags = getCrrTags(tags)
    const toggle = R.includes(tag, crrTags) ? R.without : R.concat
    const newTags = toggle([tag], crrTags)

    router.push(
      `/questions?tab=${crrTab}&tags=${newTags.join(',')}`,
      undefined,
      {
        shallow: true,
      }
    )
  }

  return (
    <>
      <S.Container>
        <S.Content>
          <S.TagsContainer>
            {tagList.map(({ slug, name }) => (
              <S.TagSlug
                onCli
                key={`tag-${slug}`}
                label={name}
                onClick={() => updateTagFilter(slug)}
                selected={R.includes(slug, tags?.split(',') || [])}
              />
            ))}
          </S.TagsContainer>
        </S.Content>
      </S.Container>
      <StyledFeed
        customTabs={tabs || []}
        onChangeTab={changeTab}
        onChangePage={changePage}
        onLoadFeed={customLoad}
        disableAskButton
        defaultTab="Popular"
        customFilters={{ tags }}
        CustomSidebar={<S.SideBar />}
      />
    </>
  )
}

AMQFeed.defaultProps = defaultProps
AMQFeed.propTypes = propTypes

export default withSizes(AMQFeed)
